import { ProxyArticle } from './articleTypes';
import { cluster1Articles } from './articles/cluster1-core';
import { cluster2Articles } from './articles/cluster2-usecases';
import { cluster3Articles } from './articles/cluster3-comparisons';
import { cluster4Articles } from './articles/cluster4-technical';
import { cluster5Articles } from './articles/cluster5-geo';
import { cluster6Articles } from './articles/cluster6-buyers';

export const allProxyArticles: ProxyArticle[] = [
  ...cluster1Articles,
  ...cluster2Articles,
  ...cluster3Articles,
  ...cluster4Articles,
  ...cluster5Articles,
  ...cluster6Articles,
];

export const getArticleBySlug = (slug: string): ProxyArticle | undefined => {
  return allProxyArticles.find(article => article.slug === slug);
};

export const getArticlesByCategory = (category: string): ProxyArticle[] => {
  return allProxyArticles.filter(article => article.category === category);
};

export const getAllCategories = (): string[] => {
  return [...new Set(allProxyArticles.map(article => article.category))];
};

export const getRelatedArticles = (slug: string, limit = 4): ProxyArticle[] => {
  const article = getArticleBySlug(slug);
  if (!article) return allProxyArticles.slice(0, limit);
  
  const related = article.relatedArticleSlugs
    .map(s => getArticleBySlug(s))
    .filter((a): a is ProxyArticle => a !== undefined);
  
  // Fill with same-category articles if not enough related
  if (related.length < limit) {
    const sameCat = allProxyArticles
      .filter(a => a.category === article.category && a.slug !== slug && !article.relatedArticleSlugs.includes(a.slug))
      .slice(0, limit - related.length);
    related.push(...sameCat);
  }
  
  return related.slice(0, limit);
};
